export default "__VITE_ASSET__CrWKkc5O__"